import React, { FC } from 'react';
import IntroImage from 'assets/images/intro.png';
import './style.scss';

type Props = {
  total_orders: number;
  completed_orders: number;
  avg_order_duration: number;
  loading: boolean;
};
const Intro: FC<Props> = ({ total_orders, completed_orders, avg_order_duration, loading }) => {
  const completed_orders_percentage = (completed_orders / total_orders) * 100;
  return (
    <div className='intro'>
      <h3 className='mb-6 intro_heading'>We see you all putting in work!</h3>
      <div className='max-w-[567px] flex items-center'>
        <p className='intro_subheading'>
          Hey, check out how awesome the team is doing! We&apos;ve spiced things up to make
          monitoring our efficiency a breeze. Now you can spot the rock stars who are totally
          crushing it. It&apos;s time to level up and take it to the next level of awesomeness!
        </p>
      </div>
      <div className='mt-8 intro_body'>
        <img src={IntroImage} alt='intro' loading='eager' />
        <div className='intro_body_card total_order_card'>
          <div className='pt-[14px] pl-[14px] pb-2'>
            <p>Total orders</p>
            <h3>{loading ? '...' : total_orders}</h3>
          </div>
        </div>
        <div className='intro_body_card completed_order_card'>
          <div className='pt-[14px] pl-[14px] pb-2'>
            <p>Orders completed</p>
            <h3>{loading ? '...' : completed_orders_percentage + '%'}</h3>
          </div>
        </div>
        <div className='intro_body_card order_duration_card'>
          <div className='pt-[14px] pl-[14px] pb-2'>
            <p>Avg. order duration</p>
            <h3>{loading ? '...' : Math.round(avg_order_duration) + 'min'}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
